// Runtime config reader.
// public/config.js runs before the app bundle and sets window.__APP_CONFIG__;
// CD overwrites config.js per environment at deploy time. Empty / whitespace
// STG_DOMAIN is a placeholder and falls through to REACT_APP_STG_DOMAIN
// (local start and per-env builds), then the production default.
export const DEFAULT_STG_DOMAIN = "freyafusion.com";

export type AppConfig = {
  STG_DOMAIN?: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

function getRuntimeConfig(): AppConfig {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }
  return {};
}

function nonEmpty(value?: string): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed || undefined;
}

export function getStgDomain(): string {
  return (
    nonEmpty(getRuntimeConfig().STG_DOMAIN) ||
    nonEmpty(process.env.REACT_APP_STG_DOMAIN) ||
    DEFAULT_STG_DOMAIN
  );
}
